<div class="tw:w-full tw:px-[15px] tw:mx-auto">
  <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">

    <div class="tw:flex-1 tw:px-[15px] tw:flex tw:justify-end">
      <!-- Add-learner entry point suppressed: Orbit is the source of record for learners (bug 37289 §7a).
           Learners are created in Orbit, then synced into LEAP; LEAP can view/edit/disable but not create.
           The /add-student screen and its API (StudentInsert) are retired to match. -->
      @if (false) {
        <div class="tile-padding-first">
          <button type="button" class="btn btn-primary tw:float-right" [routerLink]="['/add-student']">Add Learners</button>
        </div>
      }
    </div>

    <div class="tw:w-full tw:px-[15px]">

      <student-search #studentSearch [filterUx]="true"></student-search>

    </div>

  </div>
</div>